module.exports = __webpack_public_path__ + "e75d5ac83e0f3072f24da30fb901068c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/abbvie_2022_chart.png
// module id = 1619
// module chunks = 0